import React from "react";
import PropTypes from "prop-types";
import IconButton from "@/components/IconButton";
import { EditIcon } from "@/constant/imagePath";

function Actions({ row, handleOnClickEdit }) {
  return (
    <div className="w-auto flex gap-x-1 justify-center">
      <IconButton
        icon={EditIcon}
        borderColor="#E80E57"
        fromColor="#FF6060"
        toColor="#EC1060"
        onClick={() => handleOnClickEdit(row.original)}
        tooltipText="Edit"
      />
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  handleOnClickEdit: PropTypes.func.isRequired,
};

export default React.memo(Actions);
